import { Box } from "@mui/material";
import {
  DataGridPro,
  GridFooterContainer,
  GridPagination,
} from "@mui/x-data-grid-pro";

import themeInarix from "../../StylesMuiInarix";
import { ThemeProvider } from "@mui/material/styles";
import TableDashboardColumns from "./FetchingColumns";

export function DashboardTable(t: (arg0: string) => string, locale: string) {
  const { columnsValues, dashResults } = TableDashboardColumns(t);

  const paginationToolbar = () => {
    return (
      <GridFooterContainer
        sx={{ alignItems: "flex-start", justifyContent: "flex-start" }}
      >
        <GridPagination labelRowsPerPage={t("Dashboard.Users_per_page")} />
      </GridFooterContainer>
    );
  };

  return (
    <Box sx={{ height: 530 }}>
      <ThemeProvider theme={themeInarix(locale)}>
        <DataGridPro
          rows={dashResults}
          columns={columnsValues}
          pageSizeOptions={[100]}
          slots={{ footer: paginationToolbar }}
          initialState={{
            pagination: { paginationModel: { pageSize: 100 } },
          }}
          rowHeight={23.5}
          sx={{ border: "none" }}
        />
      </ThemeProvider>
    </Box>
  );
}
